import { render, staticRenderFns } from "./profilepanel.vue?vue&type=template&id=6c85c6d8&scoped=true&"
import script from "./profilepanel.vue?vue&type=script&lang=js&"
export * from "./profilepanel.vue?vue&type=script&lang=js&"
import style0 from "./profilepanel.vue?vue&type=style&index=0&id=6c85c6d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c85c6d8",
  null
  
)

export default component.exports